/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.subCustomer', [])
    .factory('subCustomerService', SubCustomerService)
    .name;

/*@ngInject*/
function SubCustomerService($http, $q) {

    var service = {
        deleteSubCustomer: deleteSubCustomer,
        getSubCustomer: getSubCustomer,
        getSubCustomers: getSubCustomers,
        saveSubCustomer: saveSubCustomer,
    }

    return service;

    function getSubCustomers () {
        var deferred = $q.defer();
        $http.get('/api/subCustomers', null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getSubCustomer (subCustomerId) {
        var deferred = $q.defer();
        var url = '/api/subCustomer/' + subCustomerId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveSubCustomer (subCustomer) {
        var deferred = $q.defer();
        var url = '/api/subCustomer';
        $http.post(url, subCustomer).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteSubCustomer (subCustomerId) {
        var deferred = $q.defer();
        var url = '/api/subCustomer/' + subCustomerId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/subcustomer.service.js